import { isAdmin } from './isAdmin';
import { isOwner } from './isOwner';
import { isWriter } from './isWriter';
import type { Member } from './types';

export function hasStrictWriterRights(member: Member) {
  return isOwner(member) || isAdmin(member) || isWriter(member);
}
